import React, { useState } from "react";

import { Row, Col, Button, Form, FormControl } from "react-bootstrap";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";

import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

import { toast } from "react-toastify";

//import Modal
import ModalUpDateStatus from "./ModalUpDateStatus";
import ModalUpDateAddress from "./ModalUpDateAddress";
import farmerService from "services/farmer.service";

function DopaList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModalAddress, setShowModalAddress] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);
  const [dopaStatus, setDopaStatus] = useState(false);
  const [dopaAddress, setDopaAddress] = useState(false);
  const [textSearch, setTextSearch] = useState("");

  const getData = () => {
    setLoading(true);
    farmerService
      .getFarmerSearch({ textSearch: textSearch })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        toast.error("error fetching data: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key
    if (e.keyCode === 13) {
      handleSearch();
    }
  };

  const handleSearchChange = (e) => {
    setTextSearch(e.target.value);
  };

  const updateStatus = (body) => {
    confirmAlert({
      title: "",
      message: "ต้องการเลือกรันระบบใหม่หรือรันต่อจากเดิม",
      buttons: [
        {
          label: "ต่อจากเดิม",
          onClick: () => {
            farmerService.setCronJobStatus(body).then((response) => {
              setDopaStatus(false);
              setDopaStatus(response.data.status);
            });
          },
        },
        {
          label: "ใหม่",
          onClick: () => {
            setLoading(true);
            farmerService
              .resetCornJobStatusCheck()
              .then((res) => {
                if (res.data.success) {
                  farmerService.setCronJobStatus(body).then((response) => {
                    setDopaStatus(false);
                    setDopaStatus(response.data.status);
                  });
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((err) => toast.error(err))
              .finally(() => setLoading(false));
          },
        },
      ],
      overlayClassName: "confirm-alert-default",
    });
  };
  const updateAddress = (body) => {
    confirmAlert({
      title: "",
      message: "ต้องการเลือกรันระบบใหม่หรือรันต่อจากเดิม",
      buttons: [
        {
          label: "ต่อจากเดิม",
          onClick: () => {
            farmerService.setCronJobAddress(body).then((response) => {
              setDopaAddress(false);
              setDopaAddress(response.data.status);
            });
          },
        },
        {
          label: "ใหม่",
          onClick: () => {
            setLoading(true);
            farmerService
              .resetCornJobAddressCheck()
              .then((res) => {
                if (res.data.success) {
                  farmerService.setCronJobAddress(body).then((response) => {
                    setDopaAddress(false);
                    setDopaAddress(response.data.status);
                  });
                } else {
                  toast.error(res.data.message);
                }
              })
              .catch((err) => toast.error(err))
              .finally(() => setLoading(false));
          },
        },
      ],
      overlayClassName: "confirm-alert-default",
    });
  };

  //   const ActionsEdit = (row) => {
  //     return (
  //       <>
  //         <i
  //           className="bi bi-pencil custom-icon-table"
  //           onClick={() => clickEdit(row.row.farmer_id)}
  //         ></i>
  //         <i
  //           className="bi bi-trash custom-icon-table"
  //           style={{ color: "red" }}
  //           onClick={() => clickDelete(row.row)}
  //         ></i>
  //       </>
  //     );
  //   };

  //   const actionsEdittFormatter = (cell, row) => {
  //     return <ActionsEdit row={row} />;
  //   };

  const columns = [
    {
      text: "ID",
      dataField: "farmer_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "fullname",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "บัตรประชาชน",
      dataField: "farmer_idcard",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ที่อยู่",
      dataField: "fulladdress",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "35%" };
      },
      style: {
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "เพศ",
      dataField: "farmer_gender",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สถานะ",
      dataField: "farmer_status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  return (
    <div>
      <ModalUpDateStatus
        show={showModalStatus}
        setShow={setShowModalStatus}
        onsubmit={updateStatus}
        status={dopaStatus}
      />
      <ModalUpDateAddress
        show={showModalAddress}
        setShow={setShowModalAddress}
        onsubmit={updateAddress}
        status={dopaAddress}
      />
      {loading ? <LoadingAlert /> : ""}
      <Row>
        <Col md={6}>
          <Form className="d-flex">
            <FormControl
              size="sm"
              type="search"
              placeholder="ค้นหาด้วย ชื่อ,นามสกุล,บัตรประชาชน"
              className="me-2"
              aria-label="Search"
              onChange={handleSearchChange}
              onKeyPress={handleKeypress}
            />
            <Button
              variant="info"
              type="submit"
              onClick={handleSearch}
              style={{ margin: 0 }}
            >
              ค้นหา
            </Button>
          </Form>
        </Col>
        <Col md={6}>
          <div style={{ textAlign: "right" }}>
            <Button
              className="btn btn-primary"
              onClick={() => setShowModalStatus(true)}
              style={{
                padding: ".375rem .75rem",
                fontSize: "1rem",
                marginRight: "0 1rem !important",
              }}
            >
              ปรับปรุงชื่อและสถานะ
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => setShowModalAddress(true)}
              style={{
                padding: ".375rem .75rem",
                fontSize: "1rem",
                marginRight: "0 1rem !important",
              }}
            >
              ปรับปรุงที่อยู่
            </Button>
          </div>
        </Col>
      </Row>
      <ToolkitProvider
        bootstrap4
        keyField="farmer_id"
        data={data}
        columns={columns}
        search
        width={100}
      >
        {(prop) => (
          <React.Fragment>
            {/* <div>
              <div className="text-left">
                <SearchBar {...prop.searchProps} />
              </div>
            </div> */}
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default DopaList;
